export default "__VITE_ASSET__77a1f0ac__"